import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["receiver"];

  dispatch(event) {
    const { name, detail } = event.params;
    const customEvent = new CustomEvent(name, { detail, bubbles: true });
    this.receiverTarget.dispatchEvent(customEvent);
  }
}
